export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40da2fb9436fd19b3b3d9b73324260a972cf5679b5&name=revalidateCommunity!'